export type RegionID = 'cinder' | 'frost' | 'foundry' | 'tempest';

export interface WorldRegion {
  id: RegionID;
  label: string;
  sky: number;
  fog: number;
  ground: number;
  ballast: number;
  rock: number;
  landmark: number;
  weather: number;
}

export interface WeatherParticleStyle {
  readonly shape: 'particle' | 'streak';
  readonly count: number;
  readonly width: number;
  readonly height: number;
  readonly opacity: number;
  readonly minimumScale: number;
  readonly scaleRange: number;
}

const regions: readonly WorldRegion[] = [
  { id: 'cinder', label: 'CINDER WASTE', sky: 0x76909b, fog: 0x71858b, ground: 0x263137, ballast: 0x42484a, rock: 0x5c4d43, landmark: 0x61463b, weather: 0xc98352 },
  { id: 'frost', label: 'WHITEOUT PASS', sky: 0x9eb6bf, fog: 0xa8bec3, ground: 0x879da0, ballast: 0x536166, rock: 0x62767d, landmark: 0x40565b, weather: 0xe9ffff },
  { id: 'foundry', label: 'FOUNDRY MILE', sky: 0x50666a, fog: 0x536467, ground: 0x242d2e, ballast: 0x353d3e, rock: 0x4a443d, landmark: 0x4f3430, weather: 0xff8a42 },
  { id: 'tempest', label: 'TEMPEST CUT', sky: 0x344550, fog: 0x3f5059, ground: 0x202a30, ballast: 0x303b40, rock: 0x44515a, landmark: 0x313d47, weather: 0x9bd9f2 },
];

const weatherStyles: Readonly<Record<RegionID, WeatherParticleStyle>> = {
  cinder: { shape: 'particle', count: 50, width: 0.045, height: 0.045, opacity: 0.42, minimumScale: 0.6, scaleRange: 1.5 },
  frost: { shape: 'particle', count: 110, width: 0.07, height: 0.07, opacity: 0.82, minimumScale: 0.6, scaleRange: 1.5 },
  foundry: { shape: 'particle', count: 110, width: 0.045, height: 0.045, opacity: 0.42, minimumScale: 0.6, scaleRange: 1.5 },
  tempest: { shape: 'streak', count: 120, width: 0.018, height: 0.78, opacity: 0.28, minimumScale: 0.5, scaleRange: 0.65 },
};

export function worldRegionForSeed(seed: number): WorldRegion {
  return regions[Math.abs(seed >>> 0) % regions.length]!;
}

export function weatherParticleStyleForRegion(region: RegionID): WeatherParticleStyle {
  return weatherStyles[region];
}

export function seedFromText(value: string): number {
  let hash = 0x811c9dc5;
  for (const character of value) {
    hash ^= character.charCodeAt(0);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}
